module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tj-e97716cafb6e3b770d5b939f587d026e.svg";